const initCatalog = async () => {
  const section = document.querySelector('.section-catalog')
  if( !section )
      return

  const {default: sectionCatalog} = await import(/* webpackChunkName: "input-mask" */ './section-catalog')
  sectionCatalog()
}

window.addEventListener('load', initCatalog)